module.exports = __webpack_public_path__ + "assets/img/63540f175e74ee3ddfc50dd22b872cd0.svg";